module.exports = __webpack_public_path__ + "style/img/Group 1785.89491ef2.png";